import { defineComponent as _defineComponent } from 'vue'
import SelectableList from '@/components/SelectableList.vue'
import SelectableItem from '@/components/SelectableItem.vue'
import QuantityControl from '@/components/QuantityControl.vue'

import { useStore } from 'vuex'
import { onMounted, ref, watch } from 'vue'
import { CtProduct } from '@/models/interfaces/content-type'

import _ from 'lodash'
import SKU from '@/utils/sku'


export default /*@__PURE__*/_defineComponent({
  __name: 'DraftProductList',
  props: {
    items: {},
    catalogue: {},
    readonly: { type: Boolean },
    valid: { type: Boolean },
    validationState: {},
    activeIndex: {},
    store: {}
  },
  emits: ['search', 'update:valid'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const $store = useStore()
const $directr = $store.getters['Services/Directr']

const props = __props

const emit = __emit
const loading = ref(false)
const dict = ref({})

function productNotRejected (ean, sku) {
  const info = (Array.isArray(props.validationState) ? props.validationState : [props.validationState]).filter(Boolean)

  return !info.some(s => s._sys && s._sys.code === 404 && s._payload && (s._payload.sku === sku || s._payload.ean === ean || s._payload.vendor?.sku === sku || s._payload.vendor?.ean === ean))
}

function validateProduct (p) {
  return !!p.sys || ((p.sku || p.ean) && parseInt(p.quantity) > 0 && productNotRejected(p.ean, p.sku))
}

// function formatDraftProductTooltip(index) {
//   const error = (Array.isArray(props.validationState) ? props.validationState[index] : props.validationState)
//   const code = error?._sys?.code || 'unknown'
//   const message = error?.message || error?._sys?.flag || ''
//   return code === 404 ? 'Product was not found' : `[${code}] ${message}`
// }

// try to fetch products from db by sku/ean using dedicated endpoint
async function checkProducts () {
  try {
    loading.value = true
    const query = (props.items || []).map(i => ({ sku: i.sku, ean: i.ean }))
    if (!query.length) return

    dict.value = (await $directr.product.search(query, props.catalogue)).items[0] || {}
  } catch (e) {
    console.error('checkProducts', e)
  } finally {
    loading.value = false
  }
}

const debouncedCheckProducts = _.debounce(checkProducts, 200)

watch(() => props.items.map(p => p.sku || p.ean), value => {
  void debouncedCheckProducts()
})

onMounted(() => {
  void debouncedCheckProducts()
})

function toSku (value: string) {
  return new SKU(value).value
}


const __returned__ = { $store, $directr, props, emit, loading, dict, productNotRejected, validateProduct, checkProducts, debouncedCheckProducts, toSku, SelectableList, SelectableItem, QuantityControl, get useStore() { return useStore }, onMounted, ref, watch, get CtProduct() { return CtProduct }, get _() { return _ }, get SKU() { return SKU } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})